import { createSlice } from "@reduxjs/toolkit";
import { loginProcess as loginProcessService } from "../../../containers/auth/auth.service";

const LoginSlice = createSlice({
  name: "login",
  initialState: {
    isLoading: false,
    errMsg: null,
  },
  /* eslint-disable no-param-reassign */
  reducers: {
    setLoading(state) {
      state.isLoading = true;
    },
    setError(state, action) {
      state.isLoading = false;
      state.errMsg = action.payload;
    },
    setSuccess(state) {
      state.isLoading = false;
      state.errMsg = null;
    },
  },
  /* eslint-enable */
});

// Extract the action creators object and the reducer
const { actions, reducer } = LoginSlice;
const { setLoading, setError, setSuccess } = actions;

// Export the reducer, either as a default or named export
export default reducer;

export const loginUser =
  ({ login_user, password_user }) =>
  async (dispatch) => {
    dispatch(setLoading());
    try {
      const response = await loginProcessService({ login_user, password_user });
      
      // Check if login was successful based on the API response structure
      if (response && response.status === 'success' && response.user) {
        dispatch(setSuccess());
        return { 
          success: true, 
          status: 'success',
          user: response.user,
          session_user: response.session_user
        };
      } else {
        const errorMessage = response?.message || "Neteisingas prisijungimo vardas arba slaptažodis";
        dispatch(setError(errorMessage));
        return { error: true, message: errorMessage };
      }
    } catch (e) {
      const errorMessage = e?.response?.data?.message || "Neteisingas prisijungimo vardas arba slaptažodis";
      dispatch(setError(errorMessage));
      return { error: true, message: errorMessage };
    }
  };
